import { useEffect, useState, useRef } from "react"
import styles from "./Ai.module.scss"
import clsx from "clsx"
import HelpAIModal from "./Container"
import { useQuery, useMutation } from "src/hooks/APIHooks"
import { getAISuggestion } from "src/graphql/queries/ai"
import { useSelector, useDispatch } from "react-redux"
import { selectSmartReportDetails } from "src/redux/slicers/buildingSummarySlice"
import { trackEvent } from "src/amplitude.js"
import { USER_EVENTS } from "src/amplitude-categories"

export const aiBotTabs = {
  systemAnalytics: "System Analytics",
  userAnalytics: "User Analytics",

}

const HelpAIButton = ({ theme }) => {

  const [openState, setOpenState] = useState(false)

  const [showHelpIcon, setShowHelpIcon] = useState(false)

  const [newDimension, setNewDimension] = useState(false)

  const [equipmentDetails, setEquipmentDetails] = useState({})

  const smartReportDetails = useSelector(selectSmartReportDetails)

  useEffect(() => {
    // show chatbot only in anomaly detection results page
    // smartReportDetails store will be set only in that page
    if (Object.keys(smartReportDetails?.data || {})?.length > 0) {
      setShowHelpIcon(true)
      trackEvent(USER_EVENTS.ANOMALY_DETECTION.events.ANOMALY_CHATBOT)
    }
  }, [smartReportDetails])

  const {
    data,
    loading,
    error,
    refetch: refetchAISuggestion,
  } = useQuery({
    query: getAISuggestion,
    disableInitialLoad: true,
    variables: { limit: 1000 },
    dataPath: "data.getAISuggestion"
  })

  useEffect(() => {
    if (openState && Object.keys(smartReportDetails?.data || {})?.length > 0) {
      // @ts-ignore
      if (equipmentDetails?.equipment_id !== smartReportDetails?.data?.equipment_id) {
        //const message = `AI is analysing the data for ${smartReportDetails?.data?.equipmentName || ''} from ${smartReportDetails?.data?.buildingName}, please wait while processing . Once data is loaded prompt your request`
        //setMessages([{ actor: "ai", message: message, type: 'systemAnalytics' }])
      }
      // setLoadingSessionData(true)
      setNewDimension(true)
      setEquipmentDetails({ ...smartReportDetails?.data, start_date: smartReportDetails?.data?.report_date, end_date: smartReportDetails?.data?.report_date })
      setTimeout(() => {
        // triggerLLMBot("", "Timeseries Analysis")
      }, 0)
    }
  }, [openState, smartReportDetails])

  useEffect(() => {
    if (Object.keys(smartReportDetails?.data || {})?.length > 0) {
      setOpenState(true)
    }
  }, [smartReportDetails])



  return showHelpIcon ? !openState
    ? <button
      onClick={() => setOpenState(!openState)}
      className={
        clsx(
          { [styles.darkbackground]: theme === "dark" },
          styles.aibutton,
        )}
    >
      {/* TODO: This isn't the same question mark icon */}
      <span className={`icon icon - question ${styles.helpaiicon} `}></span>
      Help
    </button>
    : <HelpAIModal newDimension={newDimension} reportDetails={equipmentDetails} theme={theme}
      closeModal={e => {
        setOpenState(false)
        setShowHelpIcon(false)
      }} /> : null
}

export default HelpAIButton
